import { Controller } from "@hotwired/stimulus"

// Cold-start input controller. While the translator call is in flight we:
//   1. Swap the submit button into a "Thinking…" state with a spinner,
//   2. Tell the surrounding hero to dim and overlay a translating message,
//      via the `pendingScope` target (the container with the .is-translating
//      class hook).
//
// The form is a normal Turbo Frame submission; this controller only
// provides visual feedback while the request is in flight.  When Turbo
// replaces the frame with the response, this controller is torn down
// implicitly.
export default class extends Controller {
  static targets = ["field", "submit", "label", "arrow", "spinner"]

  connect() {
    this.element.addEventListener("submit", this.onSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.onSubmit)
  }

  onSubmit = (event) => {
    if (!this.hasFieldTarget) return
    const value = this.fieldTarget.value.trim()
    if (!value) {
      event.preventDefault()
      this.fieldTarget.focus()
      return
    }
    this.setPending(true, value)
  }

  setPending(pending, question = "") {
    // NB: don't disable the <input> — disabled fields are excluded from the
    // browser's form submission, so the question wouldn't reach the server.
    // Read-only is fine for the same UX (user can't edit mid-flight).
    if (this.hasFieldTarget)   this.fieldTarget.readOnly = pending
    if (this.hasSubmitTarget)  this.submitTarget.disabled = pending
    if (this.hasLabelTarget)   this.labelTarget.textContent = pending ? "Thinking…" : "Run"
    if (this.hasArrowTarget)   this.arrowTarget.classList.toggle("hidden", pending)
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.toggle("hidden", !pending)

    // The translating overlay lives on the hero wrapper (an ancestor of
    // the form), so we walk up the DOM to find it.  closest() returns null
    // if the wrapper isn't present, which keeps this controller usable on
    // any page that mounts a report-input form without the hero.
    const heroWrapper = this.element.closest(".reports-cold-hero")
    if (heroWrapper) {
      heroWrapper.classList.toggle("is-translating", pending)
      const echoEl = heroWrapper.querySelector("[data-translating-echo]")
      if (echoEl) echoEl.textContent = `“${question}”`
    }
  }
}
